import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GoogleMapsLocations, LocationInterface } from 'types';

export type LocationsStore = {
  isLoading: boolean;
  isSvcLocationsLoading: boolean;
  errorMsg: string;
  locations: LocationInterface[];
  serviceLocations: Record<number, LocationInterface[]>;
  googleMapsCoordinates: GoogleMapsLocations[];
};

const initialState: LocationsStore = {
  isLoading: false,
  isSvcLocationsLoading: false,
  errorMsg: '',
  locations: [],
  serviceLocations: {},
  googleMapsCoordinates: []
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsSvcLocationsLoading: (state, action: PayloadAction<boolean>) => {
      state.isSvcLocationsLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    setLocations: (state, action: PayloadAction<LocationInterface[]>) => {
      state.locations = action.payload;
    },
    setServiceLocations: (
      state,
      action: PayloadAction<{
        serviceId: number;
        locations: LocationInterface[];
      }>
    ) => {
      const { serviceId, locations } = action.payload;
      state.serviceLocations[serviceId] = locations;
    },
    setGoogleMapsCoordinates: (
      state,
      action: PayloadAction<GoogleMapsLocations>
    ) => {
      state.googleMapsCoordinates = [
        ...state.googleMapsCoordinates,
        action.payload
      ];
    }
  }
});

export const {
  setIsLoading,
  setError,
  setLocations,
  setServiceLocations,
  setIsSvcLocationsLoading,
  setGoogleMapsCoordinates
} = locationSlice.actions;

export default locationSlice.reducer;
